import classNames from 'classnames';
import React, { FC, useState } from 'react';

import { ChunkedNav } from '@/types/Navigation';

import styles from '../navigation.module.scss';
import SubNavigation from '../SubNavigation';

const SubNavigationItems = ({
  navigationItems,
  activeId,
}: {
  navigationItems: ChunkedNav;
  activeId: string | undefined;
}) => {
  if (!activeId) {
    return null;
  }

  return (
    <>
      {navigationItems
        .filter(([navItem]) => activeId === navItem.id)
        .map(([navItem, subNavItems]) => {
          return <SubNavigation key={navItem.id} subMenuItemChunks={subNavItems} />;
        })}
    </>
  );
};

interface Props {
  navigationItems: ChunkedNav;
}

const TopLevelNavigation: FC<Props> = ({ navigationItems }) => {
  const [activeId, setActiveId] = useState<string | undefined>();

  const handleKeyDown = (e: KeyboardEvent, id: string) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveId(id);
    }
  };

  return (
    <div className={styles.navToplevel} onMouseLeave={() => setActiveId(undefined)}>
      <ul className={styles.navToplevelList}>
        {navigationItems?.map(([{ id, text, link }]) => (
          <li
            key={id}
            className={classNames(styles.navToplevelItem, {
              [styles.navToplevelItemActive]: activeId === id,
            })}
            onMouseEnter={() => setActiveId(id)}
            onKeyDown={(e: any) => handleKeyDown(e, id)}
          >
            <a tabIndex={0} role="button" href={link} className={styles.navToplevelItemLink}>
              {text}
            </a>
          </li>
        ))}
      </ul>

      <SubNavigationItems navigationItems={navigationItems} activeId={activeId} />
    </div>
  );
};

export default TopLevelNavigation;
